/**
 * Pemilih bahasa.
 *
 * ⚠️ Pilihannya disimpan dengan kunci yang SAMA dengan layar kasir (`osbpos.lang`): satu perangkat
 * punya satu pilihan bahasa. Dua kunci berarti manajer yang mengganti bahasa di konsol menemukan
 * layar kasirnya masih berbahasa lain — lalu menyimpulkan setelannya tak bekerja.
 */
import { Select } from 'antd';

import { LANGS, currentLang, setLang } from '../i18n';
import type { Lang } from '../i18n';

export function LanguageSwitcher() {
  return (
    <span data-testid="lang-wrap">
      <Select
        size="small"
        style={{ width: 80 }}
        defaultValue={currentLang()}
        data-testid="lang"
        onChange={(v: Lang) => { setLang(v); }}
        options={LANGS.map((l) => ({ value: l, label: l.toUpperCase() }))}
      />
    </span>
  );
}
